export default __webpack_public_path__ + "media/images/react_icons/checked_checkbox-1f4a8bdd14fda2a70cdf396e05523481.svg";